<template>
  <section>
    <b-tabs v-model="currentTabIndex" :animated="false" type="is-toggle">
      <b-tab-item :value="0" :label="$t('instructionPage.labellisations.harmonisation.title')">
        <LabellisationHarmonisationView
          v-if="currentTabIndex == 0"
          :grae-id="graeId"
          :active-quick-filter="activeQuickFilter"
        />
      </b-tab-item>

      <b-tab-item :value="1" :label="$t('instructionPage.labellisations.cloture.title')">
        <LabellisationClotureView v-if="currentTabIndex == 1" :grae-id="graeId" />
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { InfoReportingService } from "@/services/log/InfoReportingService"
import LabellisationClotureView from "./LabellisationClotureView.vue"
import LabellisationHarmonisationView from "./LabellisationHarmonisationView.vue"
import { BTabs, BTabItem } from "buefy"

export default defineComponent({
  name: "LabellisationsView",
  components: {
    LabellisationClotureView,
    LabellisationHarmonisationView,
    BTabs,
    BTabItem,
  },
  props: {
    graeId: {
      type: String,
      required: true,
    },
    activeSubTab: {
      type: Number,
      default: 0,
    },
    activeQuickFilter: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      infoReportingService: InfoReportingService.INSTANCE,
      currentTabIndex: 0,
    }
  },
  watch: {
    currentTabIndex(_newCurrentTabIndex: number, _oldCurrentTabIndex: number): void {
      const params = this.$router.currentRoute.params || {}
      const currentActiveSubTab = params["activeSubTab"] || "0"
      if (this.currentTabIndex?.toString() !== currentActiveSubTab) {
        params["activeSubTab"] = this.currentTabIndex.toString()
        this.$router.push({ params: params })
      }
    },
  },
  mounted(): void {
    this.currentTabIndex = this.activeSubTab
  },
})
</script>
